<template lang="pug">
	el-row
		el-col(:span="24")
			#principal
				.imagemPrincipal
					el-row.section(type="flex" justify="center" ref="inicio")
						el-col(:sm="15" :lg="10")#conteudo
							h2 Consulta de regularidade do imóvel
							el-row
								el-button-group
									el-col(:span="6")
										el-select(v-model="value")
											el-option(v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value")
									el-col(:span="15")
										el-input(v-bind:placeholder="frase" @keyup.enter.native="pesquisar()" v-model="codigoPesquisa" v-mask="mascara")#codigoPesquisa
									el-col(:span="3")
										el-button(v-on:click="pesquisar()")
											div(v-if="loading")
												.spinner
											div(v-if="!loading")
												magnify-icon(:title="''", height="30px", width="30px").icon
				el-row#sobre.section.cinza(type="flex" justify="center" ref="sobre")
					el-col(:sm="20" :lg="16")
						el-row
							h2.titulo Programa de Regularização Ambiental
						el-row.text-justify
							p O programa de Regularização Ambiental (PRA) foi criado para atender a necessidade de promover ações a serem desenvolvidas por proprietários e posseiros rurais visando a adequação dos imóveis rurais a legislação ambiental, através da regularização do passivo ambiental nas Áreas de Reserva Legal, Áreas de Preservação Permanente e Áreas de Uso Restrito identificadas por meio da Cadastro Ambiental Rural – CAR.
							p A regularização ambiental compreende as atividades desenvolvidas e implementadas no imóvel rural que visem atender ao disposto na legislação ambiental e, de forma prioritária, à recuperação, recomposição, regeneração dos ecossistemas em APP, de adequação do uso agrícola das áreas de uso restrito, além de permitir a par das medidas previstas para a APP, também a compensação da reserva legal, quando couber.
							p O PRA é considerado um dos mais importantes instrumentos da nova lei, já que permitirá a solução de vários passivos ambientais dos produtores rurais. Além disso, ele será um fator a ser considerado no acesso aos incentivos econômicos e financeiros dos serviços ambientais, como a Cota de Reserva Ambiental (CRA), que valoriza os ativos florestais.
						el-row
							el-col(:span="12")
								el-card
									el-row(type="flex" justify="center")
										el-col(:span="8")
											file-import-icon.icon(:title="''", height="100", width="100")
									el-row(type="flex" justify="center")
										el-col(:span="20")
											p.textCard MÓDULO OFFLINE DO PROGRAMA DE REGULARIZAÇÃO AMBIENTAL
									el-row(type="flex" justify="center")
										el-col(:span="11")
											el-button(v-on:click="abrirArquivo(urlModuloPra, '_self')") BAIXAR
												download-icon(:title="''")

							el-col(:span="12")
								el-card
									el-row(type="flex" justify="center")
										el-col(:span="8")
											book-open-variant-icon.icon(:title="''", height="100", width="100")
									el-row(type="flex" justify="center")
										el-col(:span="20")
											p.textCard MANUAL DO MÓDULO OFFLINE DO PROGRAMA DE REGULARIZAÇÃO AMBIENTAL
									el-row(type="flex" justify="center")
										el-col(:span="11")
											el-button(v-on:click="abrirArquivo('./static/publicacoes/MANUAL_PRA_OFFLINE.pdf', '_blank')") BAIXAR
												download-icon(:title="''")

				el-row(type="flex" justify="center")#legislacoes.section.branco
					el-col(:md="20" :lg="16")
						h2.titulo Legislações Relacionadas
						el-row(type="flex" justify="center")
							el-col(:sm="8" :lg="4")
								el-card
									a(href="http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2012/lei/l12651.htm", target="_blank") Lei Federal nº 12.651/2012
							el-col(:sm="8" :lg="4")
								el-card
									a(href="http://www.planalto.gov.br/ccivil_03/_Ato2011-2014/2012/Decreto/D7830.htm", target="_blank") Decreto Federal 7.830/2012

							el-col(:sm="8" :lg="4")
								el-card
									a(href="http://www.planalto.gov.br/ccivil_03/_Ato2011-2014/2014/Decreto/D8235.htm", target="_blank") Decreto Federal 8.235/2014

							el-col(:sm="8" :lg="4")
								el-card
									a(href="./static/legislacoes/Decreto_Estadual_N_1379_03_09_2015_PRA.pdf", target="_blank") Decreto Estadual nº 1379/2015

							el-col(:sm="8" :lg="4")
								el-card
									a(href="./static/legislacoes/Decreto_PRA-1653-2016.pdf", target="_blank") Decreto PRA 1.653/2016

							el-col(:sm="8" :lg="4")
								el-card
									a(href="./static/legislacoes/Instrucao_normativa-SEMAS-012016-15_02_2016.zip") Instrução Normativa SEMAS 01/2016

				el-row(type="flex" justify="center")#vantagens.section.cinza
					el-col(:sm="20" :lg="16")
						h2.titulo Principais Vantagens
						el-row(type="flex" justify="center")

							el-col(:sm="12" :lg="6").card
								.suspensao.imagem
								h3 Suspensão de Multas
								p Oportunidade de suspensão de multas ambientais através do compromisso de regularizar as áreas desmatadas.

							el-col(:sm="12" :lg="6").card
								.credito.imagem
								h3 Crédito Rural
								p Promover o acesso a crédito rural e demais programas oficiais de incentivo à produção.

							el-col(:sm="12" :lg="6").card
								.regularizacao.imagem
								h3 Regularização
								p Comprovação de que está cumprindo com a regularização ambiental.

							el-col(:sm="12" :lg="6").card
								.seguranca.imagem
								h3 Segurança Jurídica
								p Garantir segurança jurídica para a atividade produtiva.

				el-row(type="flex" justify="center" ref="perguntas")#perguntas.section.branco
					el-col(:sm="20" :lg="16")
						h2.titulo Perguntas Frequentes
						el-collapse.text-justify
							el-collapse-item(title="O que é a regularização ambiental do imóvel rural?")
								p A Regularização Ambiental do imóvel rural compreende um conjunto de ações a serem desenvolvidas no imóvel rural visando atender ao disposto na legislação ambiental, principalmente, no que se refere as áreas à manutenção e recuperação das áreas de preservação permanente, reserva legal e de uso restrito.
							el-collapse-item(title="O que é o Programa de Regularização Ambiental – PRA?")
								p É o conjunto de ações ou iniciativas a serem desenvolvidas por proprietários e posseiros rurais com o objetivo de adequar e promover a regularização ambiental nas áreas desmatadas em Áreas de Preservação Permanente, de Reserva Legal e de uso restrito, no âmbito do Cadastro Ambiental Rural – CAR.É importante ressaltar que a inscrição do CAR é condição obrigatória para adesão ao PRA.
							el-collapse-item(title="Quem pode aderir ao PRA?")
								p Art. 3º Poderão aderir ao PRA, no Estado do Pará, aqueles proprietários ou possuidores de imóveis rurais que apresentarem:
								p I - No CAR, passivos relativos à manutenção obrigatória de APP ou áreas de RL, referentes à situações anteriores a 22 de julho de 2008, nos termos da Lei Federal no 12.651, de 2012, e demais legislações aplicáveis; e/ou
								p II - Desmatamento de floresta nativa, sem autorização, em data posterior a 22 de julho de 2008, para fins de sua regularização, não sendo passíveis dos benefícios previstos nos artigos 59 a 68 da Lei Federal no 12.651 de 2012;
							el-collapse-item(title="Como realizar a adesão ao PRA?")
								p Identificada na análise do CAR a existência de passivo ambiental, o proprietário ou possuidor de imóvel rural poderá solicitar de imediato a adesão ao Programa de Regularização Ambiental - PRA, sendo necessário a elaboração do projeto de recuperação de áreas degradadas- PRADA por meio do módulo off-line do PRA que pode ser baixado no próprio site do Programa.
								p Após a elaboração do PRADA o responsável técnico deve gravar o arquivo do projeto e enviá-lo pela central do responsável técnico, cujo acesso está disponível na página do Programa. Após o envio do projeto, o sistema gera automaticamente o recibo de adesão, o PRADA com as informações que foram declaradas. Nesta etapa o usuário ficará aguardando a aprovação e liberação do termo de compromisso ambiental – TCA pelo setor jurídico para posterior download, assinatura, averbação e envio ao sistema por parte do interessado.
							el-collapse-item(title="O que é o termo de compromisso ambiental de adesão ao PRA?")
								p É o documento formal de adesão ao Programa de Regularização Ambiental – PRA, com os compromissos de manter, recuperar ou recompor Áreas de Preservação Permanente, Reservas Legais, e de uso restrito do imóvel rural, ou ainda de compensar Áreas de Reserva Legal. Trata-se de título executivo extrajudicial.
								p Cabe ressaltar que após a assinatura e enquanto estiver sendo cumprindo o Termo de Compromisso, estarão suspensas as sanções administrativas e a punibilidade de crimes e infrações cometidos antes de 22 de julho de 2008, quanto à supressão irregular de vegetação nativa em APP, reserva legal e áreas de uso restrito. A punibilidade fica extinta com a efetiva regularização ambiental atestada pelo órgão estadual assegurando que os compromissos firmados foram cumpridos.
							el-collapse-item(title="Quais os benefícios para o produtor?")
								p - Oportunidade de suspensão de multas ambientais através do compromisso de regularizar as áreas desmatadas.
								p - Promover o acesso a crédito rural e demais programas oficiais de incentivo à produção.
								p - Comprovação de que está cumprindo com a regularização ambiental.
								p - Segurança jurídica para a atividade produtiva.

				el-row(type="flex" justify="center" ref="downloads")#downloads.section
					el-col(:sm="20" :lg="16")
						h2.titulo Downloads
						el-row(type="flex" justify="center")
							el-col(:span="6")
								el-card
									p DESCRIÇÃO DAS METODOLOGIAS DE AVALIAÇÃO E MONITORAMENTO DOS PRADAS A SEREM UTILIZADOS NA SEMA-PA
									el-button(v-on:click="abrirArquivo('./static/publicacoes/DESCRICAO_DAS_METODOLOGIAS_DE_AVALIACAO_E_MONITORAMENTO_DOS_PRADAS_A_SEREM_UTILIZADOS_NA_SEMA-PA.pdf', '_blank')") BAIXAR
										download-icon(:title="''")
							el-col(:span="6")
								el-card
									p MANUAL TÉCNICO OPERATIVO DE RESTAURAÇÃO FLORESTAL DO ESTADO DO PARÁ
									el-button(v-on:click="abrirArquivo('./static/publicacoes/MANUAL_TECNICO_OPERATIVO_DE_RESTAURACAO_FLORESTAL_DO_ESTADO_DO_PARA.pdf', '_blank')") BAIXAR
										download-icon(:title="''")
							el-col(:span="6")
								el-card
									p ROTEIRO ADEQUAÇÃO AMBIENTAL
									el-button(v-on:click="abrirArquivo('./static/publicacoes/Roteiro_Adequacao_Ambiental.pdf', '_blank')") BAIXAR
										download-icon(:title="''")
							el-col(:span="6")
								el-card
									p BASE DE COBERTURA DE USO DO SOLO - ANTROPISMO - 2008-2016
									el-button(v-on:click="abrirArquivo('http://sistemas.semas.pa.gov.br/pra/arquivos-pra/mosaico_antro_08-16.zip', '_self')") BAIXAR
										download-icon(:title="''")
						el-row(type="flex" justify="center")
							el-col(:span="6")
								el-card
									p FLUXO DE SISTEMA
									el-button(v-on:click="abrirArquivo('./static/publicacoes/fluxograma-pra.pdf', '_blank')") BAIXAR
										download-icon(:title="''")
							el-col(:span="6")
								el-card
									p MÓDULO OFFLINE DO PROGRAMA DE REGULARIZAÇÃO AMBIENTAL
									el-button(v-on:click="abrirArquivo(urlModuloPra, '_self')") BAIXAR
										download-icon(:title="''")
							el-col(:span="6")
								el-card
									p MANUAL DO MÓDULO OFFLINE DO PROGRAMA DE REGULARIZAÇÃO AMBIENTAL
									el-button(v-on:click="abrirArquivo('./static/publicacoes/MANUAL_PRA_OFFLINE.pdf', '_blank')") BAIXAR
										download-icon(:title="''")

				el-row(type="flex" justify="center" ref="contatos")#contatos.section.cinza
					el-col(:sm="20" :lg="16")
						h2.titulo Fale Conosco
						el-row
							el-col
								p.negrito Secretaria de Estado de Meio Ambiente e Sustentabilidade - SEMAS
						el-row
							el-col
								p Diretoria de Ordenamento, Educação e Descentralização da Gestão Ambiental (DIORED)
								p Coordenadoria de Ordenamento e Descentralização da Gestão Ambiental (COMAM)
								p Gerência de Articulação e Adequação Ambiental (GEAR)
								p Diretoria de Tecnologia da Informação (DTI)
						el-row
							el-col(:span="1")
								.phone.icon(:title="''")
							el-col(:offset="1" :span="4")
								p (91) 3184-3654
								p (91) 3184-3652
							el-col(:span="4")
								p (91) 3184-3624
								p (91) 3184- 3314
						el-row
							el-col(:span="1")
								map-marker-outline-icon.icon(:title="''")
							el-col(:offset="1" :span="8")
								p Endereço: Travessa Lomas Valentinas, nº 2717 - Marco,
								p Belém-Pará, CEP: 66.093-677
						el-row
							el-col(:span="1")
								email-outline-icon.icon(:title="''")
							el-col(:offset="1" :span="8")
								p pra@pa.gov.br

</template>

<script>
import FileImageIcon from 'vue-material-design-icons-size/FileImage'
import FileImportIcon from 'vue-material-design-icons-size/FileImport'
import BookOpenVariantIcon from 'vue-material-design-icons-size/BookOpenVariant'
import SearchWebIcon from 'vue-material-design-icons-size/SearchWeb'
import MagnifyIcon from 'vue-material-design-icons-size/Magnify'
import DownloadIcon from 'vue-material-design-icons-size/Download'
import LockOpenIcon from 'vue-material-design-icons-size/LockOpen'
import PhoneIcon from 'vue-material-design-icons-size/Phone'
import MapMarkerOutlineIcon from 'vue-material-design-icons-size/MapMarkerOutline'
import EmailOutlineIcon from 'vue-material-design-icons-size/EmailOutline'
import GeneralService from '../../utils/services/general.service'

export default {
	name: 'HelloWorld',
	components: {
		EmailOutlineIcon,
		MapMarkerOutlineIcon,
		PhoneIcon,
		LockOpenIcon,
		DownloadIcon,
		MagnifyIcon,
		SearchWebIcon,
		BookOpenVariantIcon,
		FileImportIcon,
		FileImageIcon
	},
	data() {

		return {
			mascara: '###.###.###-##',
			codigoPesquisa: '',
			frase: ['Digite seu CPF aqui'],
			options: [{
				value: 'CPF',
				label: 'CPF'
			}, {
				value: 'CNPJ',
				label: 'CNPJ'
			}, {
				value: 'Cod. Imóvel',
				label: 'Cod. Imóvel'
			}],
			value: 'CPF',
			urlModuloPra: '',
			loading: false
		}

	},
	mounted: function() {

		var that = this

		this.$parent.$parent.$on('moveToDiv', this.moveToDiv)

		GeneralService.getConfig().then(
			function(retorno) {

				var jsonResult = JSON.parse(retorno.request.responseText)

				that.urlModuloPra = jsonResult.moduloPra

			},
			function() {

			}
		)

	},
	methods: {

		pesquisar() {

			var that = this

			this.loading = true

			that.$parent.$parent.$emit('dataPesquisa', { codigoPesquisa: that.codigoPesquisa, value: that.value })
			this.loading = false
			that.$router.push({ name: 'Resultados', query: { codigoPesquisa: that.codigoPesquisa, pagina: 1 } })

		},

		abrirArquivo: function(url, novaAba) {

			window.open(url, novaAba)

		},

		moveToDiv: function(div) {

			var that = this

			this.$nextTick(function() {

				if(that.$refs[div]) {

					var altura = that.$refs[div].$el.offsetTop - 70

					that.$parent.$el.scrollTo({
						top: altura,
						behavior: 'smooth'
					})

				}

			})

		},
		apagaDados() {

			this.mascara = ''

		}
	},
	watch: {
		value: function(newVal) {

			var that = this

			this.apagaDados()

			setTimeout(function() {

				if(newVal === 'CPF') {

					that.frase = 'Digite seu CPF aqui'
					that.mascara = '###.###.###-##'

				} else if(newVal === 'CNPJ') {

					that.frase = 'Digite o CNPJ aqui'
					that.mascara = '##.###.###/####-##'

				} else if(newVal === 'Cod. Imóvel') {

					that.frase = 'Digite o código do imóvel aqui'
					that.mascara = 'AA-#######-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX'

				}

			}, 1)

		},
		codigoPesquisa: function(newVal) {

			this.codigoPesquisa = newVal.toUpperCase()

		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/views/Principal.vue